<template>
    <app-layout title="Add Chain">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Add Chain</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="h-7 leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button class="h-7 leading-none" :disabled="form.processing" :href="route('chains.index')">
                        {{ form.isDirty ? 'Cancel' : 'Close' }}
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="px-8 xl:flex">
                <chain-customer-form
                    :form="form"
                    :customers="customers"
                />

                <chain-customer-pricing-form
                    :form="form"
                    :pricing-products-url="route('chains.pricing_products')"
                    :chain-id="form.id"
                />
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import ChainCustomerForm from '@/Pages/Chains/Partials/ChainCustomerForm';
import ChainCustomerPricingForm from '@/Pages/Chains/Partials/ChainCustomerPricingForm';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    setup() {
        const form = useForm({
            id: null,
            code: null,
            name: null,
            address_1: null,
            address_2: null,
            city: null,
            postal_code: null,
            province: 'Ontario',
            phone: null,
            email: null,
            contact_name: null,
            customers: [],
            pricing: [],
            products: [],
            favourites_by_product: {},
            customer_favourites_visible_only: false,
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
        ChainCustomerForm,
        ChainCustomerPricingForm,
    },

    props: [
        'customers',
    ],

    data() {
        return {
            showDeleteModal: false,
        }
    },

    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    customers: data.customers.map(c => c.id),
                }))
                .post(route('chains.store'));
        }
    },
}
</script>

<style scoped>

</style>
